export class Income {

  income_id: number
  person: string
  amount: number
  date: string
  comment: string

  constructor(data: any = {}) {
    this.income_id = data.income_id
    this.person = data.person
    this.amount = data.amount
    this.date = data.date
    this.comment = data.comment
  }

  get editLink(): string {
    return `/finance/other-income/edit/${this.income_id}`
  }

}



// WEBPACK FOOTER //
// ./src/app/models/finance/income.ts